const WINE_TYPE_LABELS = {
    RED: 'Red',
    WHITE: 'White',
    ROSE: 'Rosé',
    SPARKLING: 'Sparkling',
    DESSERT: 'Dessert',
    FORTIFIED: 'Fortified',
    OTHER: 'Other',
};
export const formatWineType = (wineType) => {
    if (wineType in WINE_TYPE_LABELS) {
        return WINE_TYPE_LABELS[wineType];
    }
    return wineType;
};
/**
 * Check if user can edit a wine based on their role and venue admin status
 */
export const canEditWine = (wine, userRole, userId, venue) => {
    // SITE_ADMIN and SUPER_ADMIN can edit any wine
    if (userRole === 'SITE_ADMIN' || userRole === 'SUPER_ADMIN') {
        return true;
    }
    // VENUE_ADMIN can edit wines from venues they are assigned to
    if (userRole === 'VENUE_ADMIN') {
        // If venue is provided, check if user is admin of that venue
        if (venue) {
            return Boolean(venue.venueAdmins?.includes(userId));
        }
        // If no venue provided, we can't determine permission
        return false;
    }
    return false;
};
/**
 * Check if a wine has enhanced data fields
 */
export const hasEnhancedData = (wine) => {
    return Boolean(wine.appellation ||
        wine.subAppellation ||
        wine.descriptors.length > 0 ||
        wine.professionalScores.length > 0 ||
        wine.holdUntil ||
        wine.drinkBefore);
};
/**
 * Check if a wine has professional scores
 */
export const hasProfessionalScores = (wine) => {
    return wine.professionalScores.length > 0;
};
/**
 * Get the count of professional scores for a wine
 */
export const getProfessionalScoreCount = (wine) => {
    return wine.professionalScores.length;
};
/**
 * Check if a wine has a drinking window defined
 */
export const hasDrinkingWindow = (wine) => {
    return Boolean(wine.holdUntil || wine.drinkBefore);
};
/**
 * Get wine display name (fallback to name if no display name)
 */
export const getWineDisplayName = (wine) => {
    return wine.name;
};
/**
 * Format wine vintage for display
 */
export const formatWineVintage = (wine) => {
    return wine.vintage ? wine.vintage.toString() : 'NV';
};
/**
 * Check if wine is currently available
 */
export const isWineAvailable = (wine) => {
    return wine.availability !== 'not available';
};
